export const initModals = () => {
  const modalTriggers = document.querySelectorAll(".modalTrigger");
  modalTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (event) => {
      const modalId = trigger.getAttribute("data-modal-id");
      openModal(modalId, event);
    });
  });
};

export const openModal = (modalId?: string | null, event?: any) => {
  if (!modalId) {
    return;
  }

  if (event) {
    event.preventDefault();
  }

  const modal = document.getElementById(modalId) as HTMLDialogElement;

  if (!modal) {
    return;
  }

  const onTransitionEnd = () => {
    modal.removeEventListener("transitionend", onTransitionEnd);
    modal.close();
  };

  const closeButtons = modal.querySelectorAll(".close");

  closeButtons.forEach((closeButton) => {
    closeButton.addEventListener("click", () => {
      modal.addEventListener("transitionend", onTransitionEnd);
      modal.classList.remove("active");
    });
  });

  // Add the event listener for transitionend
  modal.showModal();
  modal.classList.add("active");
};

export const autoOpenModal = () => {
  // @ts-ignore
  if (typeof modalId === "undefined") {
    return;
  }
  // @ts-ignore
  openModal(modalId);
};

initModals();
autoOpenModal();
